import { Flex, UploadFile } from 'antd';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';
import { formatFileSize } from 'app/modules/service/utils/file';

type ErrorType = 'maxSize' | 'uploadFailed' | 'unsupportedFileType';

interface ErrorMessageProps {
  file: UploadFile;
  type: ErrorType;
}

export const ErrorMessage = ({ file, type }: ErrorMessageProps): JSX.Element => {
  const { t } = useTranslation();

  const getErrorMessage = (): string => {
    switch (type) {
      case 'maxSize':
        return t('service.issueDescription.errors.maxFileSize', { fileSize: formatFileSize(file.size) });
      case 'uploadFailed':
        return t('service.issueDescription.errors.uploadFailed', { fileName: file.name });
      case 'unsupportedFileType':
        return t('service.issueDescription.errors.unsupportedFileType', { fileName: file.name });
      default:
        return t('service.issueDescription.errors.uploadFailed', { fileName: file.name });
    }
  };

  return (
    <Flex key={file.uid} align="center" gap={6}>
      <SvgIcon name="warningCritical" className="warning-critical-icon" />
      {getErrorMessage()}
    </Flex>
  );
};
